import List from './List';
import Detail from './Detail';
import UpdateSamples from './UpdateSamples';

export {
    List,
    Detail,
    UpdateSamples,
};
